import axios from 'axios'
import store from './store'

const buildApi = (url) => {
  const api = axios.create({
    baseURL: url
  })

  api.interceptors.request.use((config) => {
    if (localStorage.getItem('accessToken')) {
      let headers = config.headers
      headers['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken')
      headers['User-Agent'] = 'nurtur/members'
    }

    return config
  }, (error) => {
    return Promise.reject(error)
  })

  api.interceptors.response.use((response) => {
    return response
  }, (error) => {
    if (!error.response) {
      return Promise.reject(error)
    }

    let status = error.response.status
    if (status === 401) {
      if (error.response.data.error === 'incorrect hub') {
        window.location = error.response.data.redirect
      } else {
        store.dispatch('logout')
      }
    } else if (status === 403) {
      store.dispatch('displayToastNotification', {
        type: 'danger',
        icon: 'fa-lock',
        title: 'Unauthorized',
        info: 'You don\'t have the necessary permissions to view that content'
      })
    }

    return Promise.reject(error)
  })

  return api
}

const propertyLogicApi = buildApi(process.env.VUE_APP_PROPERTY_LOGIC_ROOT_API + '/members')
const api = buildApi(process.env.VUE_APP_ROOT_API + '/members')
const v2Api = buildApi(process.env.VUE_APP_ROOT_API + '/v2')

export { propertyLogicApi, api as default, v2Api }
